import { Box, Typography } from "@mui/material";

const Home = () => {
  return (
    <Box>
      <Typography variant="h4">Home</Typography>
    </Box>
  );
};

export default Home;
